// Copyright (c) 2020 WiseTime. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/type/seat/seat_policy.proto (package wisetime.type.seat, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file wisetime/type/seat/seat_policy.proto.
 */
export const file_wisetime_type_seat_seat_policy: GenFile = /*@__PURE__*/
  fileDesc("CiR3aXNldGltZS90eXBlL3NlYXQvc2VhdF9wb2xpY3kucHJvdG8SEndpc2V0aW1lLnR5cGUuc2VhdCqCAQoUU2VhdEFsbG9jYXRpb25Qb2xpY3kSJgoiU0VBVF9BTExPQ0FUSU9OX1BPTElDWV9VTlNQRUNJRklFRBAAEhAKDFNFTEZfTUFOQUdFRBABEhEKDVNBTEVTX01BTkFHRUQQAiIECAMQAyoXTUVNQkVSU0hJUF9BVVRPX1BST1JBVEFCKgoVY29tLndpc2V0aW1lLmFwaS50eXBlQg9TZWF0UG9saWN5UHJvdG9QAGIGcHJvdG8z");

/**
 * @generated from enum wisetime.type.seat.SeatAllocationPolicy
 */
export enum SeatAllocationPolicy {
  /**
   * @generated from enum value: SEAT_ALLOCATION_POLICY_UNSPECIFIED = 0;
   */
  SEAT_ALLOCATION_POLICY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: SELF_MANAGED = 1;
   */
  SELF_MANAGED = 1,

  /**
   * do not allow stripe subscription changes if SALES_MANAGED
   *
   * @generated from enum value: SALES_MANAGED = 2;
   */
  SALES_MANAGED = 2,
}

/**
 * Describes the enum wisetime.type.seat.SeatAllocationPolicy.
 */
export const SeatAllocationPolicySchema: GenEnum<SeatAllocationPolicy> = /*@__PURE__*/
  enumDesc(file_wisetime_type_seat_seat_policy, 0);

